import axios from 'axios'

let BASE_API = 'http://api.qimenpan.com'

const api = axios.create({
  baseURL: BASE_API,
  timeout: 3000,
  withCredentials: true
})

// // request interceptor
// api.interceptors.request.use(config => {
//   let token = "12345"
//   if (token) {
//     // 服务端准备好 就可以上token了
//     config.headers['token'] =  "12345"
//   }
//   return config
// }, error => {
//   // Do something with request error
//   // console.log(error) // for debug
//   Promise.reject(error)
// })


export default api